import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import useGuardianTransportService, {
  GuardianTransportData,
  GuardianTransportHistory,
} from 'src/apis/guardian/sub-apis/useGuardianTransportService';
import { TPaginationParams } from 'src/apis/__shared/shared.interfaces';
import { IFHError } from 'src/apis/HttpBaseApiWrapper';

export const GUARDIAN_TRANSPORT_QUERY_KEY = 'guardianTransport';
export const GUARDIAN_TRANSPORT_HISTORY_QUERY_KEY = 'guardianTransportHistory';
type TQueryError = IFHError<{ message: string }>;

export const useGuardianTransportHook = (
  studentId: string,
  options?: UseQueryOptions<GuardianTransportData, TQueryError>
): UseQueryResult<GuardianTransportData, TQueryError> => {
  const { getTransportData } = useGuardianTransportService();

  return useQuery<GuardianTransportData, TQueryError>({
    queryKey: [GUARDIAN_TRANSPORT_QUERY_KEY, studentId],
    queryFn: () => getTransportData(studentId),
    enabled: !!studentId,
    ...options,
  });
};

export const useGuardianTransportHistoryHook = (
  studentId: string,
  params: TPaginationParams & { fromDate?: string; toDate?: string },
  options?: UseQueryOptions<
    { data: GuardianTransportHistory[]; count: number },
    TQueryError
  >
): UseQueryResult<{ data: GuardianTransportHistory[]; count: number }, TQueryError> => {
  const { getTransportHistory } = useGuardianTransportService();

  return useQuery<
    { data: GuardianTransportHistory[]; count: number },
    TQueryError
  >({
    queryKey: [
      GUARDIAN_TRANSPORT_HISTORY_QUERY_KEY,
      studentId,
      params,
    ],
    queryFn: () =>
      getTransportHistory(studentId, {
        ...params,
        page: params.page ?? 1,
        limit: params.limit ?? 10,
      }),
    enabled: !!studentId,
    ...options,
  });
};
